<template>
  <div v-loading="loading">
    <vxe-grid
      keep-source
      class="invoiceTable bigTable scrollBg"
      show-overflow
      auto-resize
      show-header-overflow
      show-footer
      :footer-method="footerMethod"
      :ref="refname"
      resizable
      :max-height="maxHeight"
      :columns="names"
      :data="datas"
      highlight-hover-row
      BatchDetailList
      scroll-x.rSize
    >
      <!-- 自定义列模板 -->
      <template v-slot:costCenter="{ row }">
        <span>{{ row.costCenter | getCostCenter }}</span>
      </template>
      <template v-slot:trusteeOrgId="{ row }">
        <span>{{ row.trusteeOrgId | pubOrgName }}</span>
      </template>
      <template v-slot:empName="{ row }">
        {{ row.empName }}
        <div v-if="row.error && row.error.length > 0" class="inlineBlock">
          <el-popover
            popper-class="loopBox"
            placement="bottom-start"
            width="296"
            trigger="hover"
          >
            <svg class="icon popIcon" aria-hidden="true" slot="reference">
              <use xlink:href="#icon-tishi"></use>
            </svg>
            <div class="loopError" v-for="item in row.error" :key="item">
              <div class="loopType loopTypeInfo" v-if="item.type === 'info'">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-cuowu"></use>
                </svg>
                提示
              </div>
              <div class="loopType loopTypeError" v-if="item.type === 'error'">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-guanbi"></use>
                </svg>
                错误
              </div>
              <div class="loopType loopTypeWarn" v-if="item.type === 'warning'">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-cuowu"></use>
                </svg>
                警告
              </div>
              <div class="loopContent" v-for="(msg, index) in item.data" :key="index">
                <p>{{ index }}. {{ msg }}</p>
              </div>
            </div>
          </el-popover>
        </div>
      </template>
      <!-- 空状态 -->
      <template v-slot:empty>
        <span>
          <svg class="icon icon-kong" aria-hidden="true">
            <use xlink:href="#icon-kong"></use>
          </svg>
          <p class="noData">暂无数据</p>
        </span>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import { floatSum, formatFloat } from '@/util/util';

let that;

export default {
  name: 'dataTable',
  props: {
    isUpdate: {
      type: Boolean,
      default: false,
    },
    names: {
      type: Array,
      default: () => [],
    },
    datas: {
      type: Array,
      default: () => [],
    },
    refname: {
      type: String,
      default: '',
    },
    costCenterList: {
      type: Array,
      default: () => [],
    },
    pubOrgIdList: {
      type: Array,
      default: () => [],
    },
    amountColumns: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    datas: {
      handler(newVal) {
        this.$emit('update:bigDatas', newVal);
        this.loading = false;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      loading: true,
      maxHeight: document.documentElement.clientHeight - 246 + 'px',
    };
  },
  beforeCreate() {
    that = this;
  },
  created() {
    this.loading = true;
  },
  mounted() {
    // 确保表格加载完成后关闭 loading（如果 datas 为空也会触发 watch）
    this.$nextTick(() => {
      this.loading = false;
    });
  },
  filters: {
    getCostCenter(center) {
      let name = '';
      for (let i = 0; i < that.costCenterList.length; i++) {
        const item = that.costCenterList[i];
        if (center === item.id) {
          name = item.costName;
          break;
        }
      }
      // 没匹配到（或匹配到但 costName 为空）时返回原值
      return name || center;
    },
    pubOrgName(orgId) {
      const len = that.pubOrgIdList.length;
      for (let i = 0; i < len; i++) {
        const item = that.pubOrgIdList[i];
        if (orgId === item.pubOrgId) {
          return item.company;
        }
      }
      return '';
    },
  },
  methods: {
    /**
     * 页脚合计方法
     * @param {Object} params - 包含 columns 和 data
     * @returns {Array} 合计行数组（只有一行）
     */
    footerMethod({ columns, data }) {
      console.log('amountColumns:', this.amountColumns);
      console.log('columns fields:', columns.map(c => c.field));
      const sumRow = columns.map((column, index) => {
        // 第一列显示 "合计"
        if (index === 0) {
          return '合计';
        }
        // 如果该列字段在 amountColumns 中，则计算合计
        if (this.amountColumns.includes(column.field)) {
          const values = data
            .map((row) => row[column.field])
            .filter((val) => val !== undefined && val !== null && val !== '');
          if (values.length === 0) {
            return null;
          }
          // 使用 floatSum 求和，并保留两位小数（可根据需要调整）
          const sum = floatSum(values);
          return formatFloat(sum, 2);
        }
        // 其他列返回 null（不显示）
        return null;
      });
      return [sumRow];
    },
  },
};
</script>

<style scoped>
/* 主表格样式 */
.bigTable >>> .vxe-header--column.col-red {
  background-color: red;
  color: #fff;
}

/* 编辑状态下的脏数据标记 */
.bigTable >>> .vxe-table.vxe-editable .vxe-body--column.col--dirty:before {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: none;
  transform: none;
  background: rgba(245, 202, 45, 0.56);
  z-index: 1;
}
.bigTable >>> .vxe-table.vxe-editable .vxe-body--column.col--dirty .vxe-cell {
  position: relative;
  z-index: 5;
  font-weight: bold;
  font-size: 14px;
}

/* 隐藏输入框后缀 */
.bigTable >>> .vxe-input--extra-suffix {
  display: none;
}

/* 空状态图标 */
.icon-kong {
  font-size: 80px;
  color: #c0c4cc;
}

/* 页脚样式（可选调整） */
.bigTable >>> .vxe-footer--row .vxe-body--column {
  font-weight: bold;
  background-color: #f5f7fa;
}
</style>
